"use client";

import { usePathname } from "next/navigation";
import { VClick } from "./VClick";

const ENTRY_ROUTES = ["/auth", "/login", "/register"];

/** Keep the floating workspace controls off authentication and enrolment pages. */
export function VClickRouteBoundary() {
  const pathname = usePathname();
  if (!pathname || ENTRY_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`))) {
    return null;
  }
  return <VClick />;
}
